import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";
import "../styles/TicketSearchPage.css";
import StyledButton from "../../../components/StyledButton.jsx";

class TicketSearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticketNumber: "",
            emailAddress: "",
            issue: null
        };
    }

    componentWillLoad() {
        this.props.resetTicket();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.ticketSearching === false &&
            prevProps.ticketSearching === true &&
            !this.props.ticketSearchingError &&
            this.props.ticketSearchData &&
            this.props.ticketSearchData.result
        ) {
            window.localStorage.setItem("-rma-jwt", this.props.ticketSearchData.result.auth_token);
            this.props.history.push(`/tickets?id=${this.props.ticketSearchData.result.ticket_id}`);
        }

        if (this.props.ticketSearching === false && prevProps.ticketSearching === true && this.props.ticketSearchingError) {
            this.setState({
                issue: this.props.ticketSearchingError
            });
        }
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSubmitClick(e) {
        e.preventDefault();
        this.props.searchTicket(this.state.ticketNumber, this.state.emailAddress);
    }

    isSubmitButtonEnabled() {
        return !this.props.ticketSearching;
    }

    getHelperText(fieldName) {
        if (
            this.props.ticketSearchingError &&
            this.props.ticketSearchingData &&
            this.props.ticketSearchingData.validationErrors &&
            this.props.ticketSearchingData.validationErrors.some(ve => ve.fieldName === fieldName)
        ) {
            var valdiationError = this.props.ticketSearchingData.validationErrors.filter(ve => ve.fieldName === fieldName)[0];
            let errorMessage = valdiationError.errorMessage;
            let errrorData = valdiationError.data;
            let helperText = errorMessage;
            if (errrorData) {
                helperText = helperText + ` (${errrorData})`;
            }

            return helperText;
        }
    }

    getIssueLabel() {
        if (this.state.issue) {
            if (locales[this.props.language.code].TICKET_SEARCH.ISSUE[this.state.issue]) {
                return locales[this.props.language.code].TICKET_SEARCH.ISSUE[this.state.issue];
            } else {
                if (!this.getHelperText("ticket_number") && !this.getHelperText("email_address")) {
                    return locales[this.props.language.code].TICKET_SEARCH.ISSUE.ERROR;
                }
            }
        }

        return "";
    }

    render() {
        return (
            <div className="layout vertical center ticket-search-page-container">
                <section className="flex layout center ticket-search-page">
                    <div className="header" />
                    <div>
                        <div className="section">
                            <div className="section-header">
                                <div className="layout horizontal center title-row">
                                    <h1 className="title">{locales[this.props.language.code].TICKET_SEARCH.TITLE}</h1>
                                </div>
                                <div className="subtitle">{locales[this.props.language.code].TICKET_SEARCH.SUBTITLE}</div>
                            </div>
                            <div className="section-body">
                                <div className="flex layout vertical section-body-box">
                                    <form className="flex layout vertical" autoComplete="off" onSubmit={this.handleSubmitClick.bind(this)}>
                                        <TextField
                                            autoComplete="off"
                                            error={this.getHelperText("ticket_number") ? true : false}
                                            value={this.state.ticketNumber}
                                            name="ticketNumber"
                                            onChange={this.handleChange.bind(this)}
                                            className="flex custom-textfield"
                                            label={locales[this.props.language.code].TICKET_SEARCH.TICKET_NUMBER.LABEL}
                                            variant="outlined"
                                            helperText={this.getHelperText("ticket_number")}
                                            InputLabelProps={{
                                                shrink: true,
                                                htmlFor: "ticket_number"
                                            }}
                                            inputProps={{ id: "ticket_number", maxLength: 15 }}
                                        />
                                    </form>
                                    <form className="flex layout vertical" autoComplete="off" onSubmit={this.handleSubmitClick.bind(this)}>
                                        <TextField
                                            autoComplete="off"
                                            error={this.getHelperText("email_address") ? true : false}
                                            value={this.state.emailAddress}
                                            name="emailAddress"
                                            onChange={this.handleChange.bind(this)}
                                            className="flex custom-textfield"
                                            label={locales[this.props.language.code].TICKET_SEARCH.EMAIL_ADDRESS.LABEL}
                                            variant="outlined"
                                            helperText={this.getHelperText("email_address")}
                                            InputLabelProps={{
                                                shrink: true,
                                                htmlFor: "email_address"
                                            }}
                                            inputProps={{ id: "email_address", maxLength: 50 }}
                                        />
                                    </form>
                                    {this.state.issue && (
                                        <div className="issue-box flex layout horizontal">
                                            <div className="flex layout horizontal center">
                                                <span style={{ color: "#bf0000", fintWeight: 500 }}>{this.getIssueLabel()}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="section-footer layout horizontal end-justified">
                                <div className="flex layout horizontal end-justified section-footer-box">
                                    <StyledButton
                                        id="submit-button-id"
                                        disabled={!this.isSubmitButtonEnabled()}
                                        onClick={this.handleSubmitClick.bind(this)}
                                        variant="contained"
                                    >
                                        {locales[this.props.language.code].BUTTON.SEARCH.LABEL}
                                        {this.props.ticketSearching && <CircularProgress className="button-progress" size={16} thickness={4} />}
                                    </StyledButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer layout horizontal end-justified"></div>
                </section>
            </div>
        );
    }
}

export default withRouter(TicketSearchPage);
